import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';


@Component({
  selector: 'app-account-created-confirmation',
  templateUrl: './account-created-confirmation.component.html',
  styleUrls: ['./account-created-confirmation.component.scss'],
})
export class AccountCreatedConfirmationComponent implements OnInit {
  emailAccountCreatedFlag: boolean = false;
  boydRewardConnectFlag: boolean = false;
  boydRewardApplySuccessFlag: boolean = false;
  boydRewardApplyFailFlag: boolean = false;
  boydRewardCognitoConnectFlag: boolean = false;
  cardNumber;
  userName;
  public feautureCustomerSupportURL: string;
  constructor(
    private navigator: Navigator,
    private galleryService: GalleryService,
    private navParams: NavParams,
    private config: ConfigService,
    private appLinks: AppLinksService
  ) { }

  ngOnInit() {
    this.emailAccountCreatedFlag = this.navParams.data.emailAccountCreatedFlag ? this.navParams.data.emailAccountCreatedFlag : false;
    this.boydRewardConnectFlag = this.navParams.data.boydRewardConnectFlag ? this.navParams.data.boydRewardConnectFlag : false;
    this.boydRewardApplySuccessFlag = this.navParams.data.boydRewardApplySuccessFlag ? this.navParams.data.boydRewardApplySuccessFlag : false;
    this.boydRewardApplyFailFlag = this.navParams.data.boydRewardApplyFailFlag ? this.navParams.data.boydRewardApplyFailFlag : false;
    this.boydRewardCognitoConnectFlag = this.navParams.data.boydRewardCognitoConnectFlag ? this.navParams.data.boydRewardCognitoConnectFlag : false;
    this.cardNumber = this.navParams.data.cardNumber;
    this.userName = this.navParams.data.userName;
    this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL;
  }

  close() {
    this.navigator.dismissAll();
  }

  ngOnDestroy() {
    this.galleryService.getGameList();
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

}
